module.exports = __webpack_public_path__ + "static/img/047贷款app.f60dfea.png";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/047贷款app.png
// module id = S1ub
// module chunks = 0